<template>
  <div>
    <div :class="['image-selected', className]" v-if="image">
      <i
        class="el-icon-circle-close"
        @click="handleRemoveImage"
        v-show="!disabled"
      ></i>
      <img :src="image" class="image" />
    </div>
    <el-upload
      :disabled="disabled"
      action="#"
      :auto-upload="false"
      :class="['avatar-uploader', { 'avatar-uploader--drag': drag }]"
      :show-file-list="showFileList"
      ref="upload"
      accept=".png, .jpg, .jpeg"
      :limit="1"
      :on-change="handleChangeFile"
      :drag="drag"
      v-else
    >
      <div>
        <i :class="icon" class="avatar-uploader-icon"></i>
        <div class="el-upload__text">
          <a href="#" class="a-link"
            ><strong class="small font-semi-bold">{{ title }}</strong></a
          >
        </div>
        <p v-if="drag" class="avatar-uploader-hint">o arrastra aquí</p>
      </div>
    </el-upload>
  </div>
</template>

<script>
import { fileBase64 } from "@/assets/utils/files";

export default {
  name: "FileUploadComponent",
  data() {
    return {
      image: this.preview
    };
  },
  watch: {
    preview(v) {
      this.image = v;
    }
  },
  methods: {
    async handleChangeFile(file) {
      let base64 = await fileBase64(file.raw);
      this.image = base64;
      this.emitFileData();
    },
    handleRemoveImage() {
      this.image = null;
      this.emitFileData();
    },

    emitFileData() {
      this.$emit("fileBase64", this.image);
    }
  },
  props: {
    icon: {
      default: "el-icon-picture-outline-round"
    },
    title: {
      default: ""
    },
    preview: {
      default: null
    },
    className: {
      default: null
    },
    showFileList: {
      default: true
    },
    disabled: {
      default: false
    },
    drag: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$root.$on("cleanFileUpload", () => {
      this.image = null;
    });
  }
};
</script>

<style lang="scss" scoped>
.avatar-uploader {
  border-radius: 6px;
  max-width: 150px;
  padding: 2rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: dashed 1px #e3e3e3 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader--drag {
  border: none !important;
  padding: 0;
  max-width: 100%;
  margin: 0 auto;
}
.avatar-uploader--drag ::v-deep .el-upload {
  width: 100%;
}
.avatar-uploader--drag ::v-deep .el-upload-dragger {
  border-radius: 10px;
  border: dashed 1.5px #d9d9d9;
  width: 100%;
  height: auto;
  padding: 28px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s;

  &:hover {
    border-color: #3fdbbf;
  }
}
.avatar-uploader-hint {
  font-size: 12px;
  color: #9b9bab;
  margin: 6px 0 0;
}
.avatar-uploader-icon {
  font-size: 48px;
  color: #d9d9d9;
  text-align: center;
  margin-bottom: 8px;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.image-selected {
  i {
    font-size: 1.5rem;
    float: right;
    cursor: pointer;
  }

  img {
    display: block;
    margin: auto;
    max-width: 350px;
    width: 100%;
  }

  &.image-profile {
    img {
      height: 140px !important;
      width: 140px !important;
      border-radius: 50% !important;
      object-fit: contain;
      background: #fff;
      border: 2px solid #e4eaf6;
      padding: 0;
    }
  }
}
</style>
